export enum ShareActionType {
  WhatsApp = 'whatsApp',
  AddToSpectrum = 'addToSpectrum',
  CopyLink = 'copyLink',
  CopyLinkWithInfo = 'copyLinkWithInfo',
  Email = 'email',
  QrCode = 'qrCode',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Pinterest = 'pinterest',
  NativeShare = 'nativeShare',
}

export type SocialShareActionType =
  | ShareActionType.WhatsApp
  | ShareActionType.Facebook
  | ShareActionType.Twitter
  | ShareActionType.Pinterest;

export function isShareActionType(value: unknown): value is ShareActionType {
  return Object.values(ShareActionType).includes(value as ShareActionType);
}
